import { Dialog, Button } from '@teachstonellc/component-library';
import submitIcon from 'images/reliabilityTest/submitIcon.svg';

interface ConfirmationModalProps {
  title: React.ReactNode;
  message: React.ReactNode;
  dismissButtonText: string;
  confirmButtonText: string;
  onConfirm: () => void;
  onCancel: () => void;
  onClose: () => void;
  isOpen: boolean;
  modalIcon?: string;
  isLoading?: boolean;
}

function ConfirmationModal({
  title,
  message,
  dismissButtonText,
  confirmButtonText,
  onConfirm,
  onCancel,
  onClose,
  isOpen,
  modalIcon,
  isLoading
}: ConfirmationModalProps) {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={open => !open && !isLoading && onClose()}
      title={title}
      titleClassName="text-center text-[#364A5E]"
      contentClassName="max-w-[92vw] sm:max-w-[642px] !rounded-[17px] px-8"
      overlayClassName="!bg-[rgba(0,0,0,0.63)]"
      actionButton={
        <div className="w-full flex gap-4 pt-4">
          <Button
            variant="secondary"
            className="flex-1"
            onClick={onCancel}
            disabled={isLoading}
          >
            {dismissButtonText}
          </Button>
          <Button
            variant="primary"
            className="flex-1"
            onClick={onConfirm}
            disabled={isLoading}
            loading={isLoading}
          >
            {confirmButtonText}
          </Button>
        </div>
      }
    >
      <img src={modalIcon || submitIcon} alt="" className="w-20 mx-auto mb-8" />
      {message}
    </Dialog>
  );
}

export default ConfirmationModal;
